"use client";

import { ArrowRight, CalendarCheck, ChefHat, PhoneCall, Sparkles } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyForAGreenerLawn() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const trustSignals = [{
    icon: CalendarCheck,
    label: "Precision Mowing"
  }, {
    icon: ChefHat,
    label: "Expert Edging"
  }, {
    icon: Sparkles,
    label: "Clean Trimming"
  }];
  return <section data-section-id="710" id="ready-for-a-greener-lawn" className="dark bg-background text-foreground relative min-h-[80vh] w-full overflow-hidden bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696120/img/acosta_landscaping_perfect_lawn.png)] bg-cover bg-center bg-fixed">
      {}
      <div className="absolute inset-0 hidden md:block" style={{
      background: "linear-gradient(to right, hsl(150 20% 6% / 0.95) 0%, hsl(150 20% 6% / 0.8) 35%, hsl(150 20% 6% / 0.45) 70%, hsl(150 20% 6% / 0.2) 100%)"
    }} aria-hidden="true" />
      {}
      <div className="absolute inset-0 md:hidden" style={{
      background: "linear-gradient(to bottom, hsl(150 20% 6% / 0.85) 0%, hsl(150 20% 6% / 0.95) 100%)"
    }} aria-hidden="true" />

      {}
      <div className="absolute top-8 right-6 md:top-12 md:right-12 z-20 pointer-events-none">
        <div className="rounded-md border px-4 py-2 text-[0.7rem] tracking-[0.25em] font-mono uppercase backdrop-blur-sm" style={{
        color: "hsl(142 76% 45%)",
        borderColor: "hsl(142 76% 45% / 0.5)",
        backgroundColor: "hsl(150 20% 6% / 0.6)",
        transform: "rotate(0deg)"
      }}>
          <span className="inline-flex items-center gap-2">
            <span className="inline-block size-1.5 rounded-lg" style={{
            backgroundColor: "hsl(142 76% 45%)"
          }} />
            [MOW.01]
            <span className="inline-block size-1.5 rounded-lg" style={{
            backgroundColor: "hsl(142 76% 45%)"
          }} />
            PREMIUM CARE
            <span className="inline-block size-1.5 rounded-lg" style={{
            backgroundColor: "hsl(142 76% 45%)"
          }} />
          </span>
        </div>
      </div>

      {}
      <div ref={ref} className={`relative z-10 flex min-h-[80vh] items-center px-6 py-24 md:px-12 lg:px-16 md:py-32 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="w-full md:w-3/5 lg:w-1/2 text-center md:text-left">
          {}
          <div className="mb-6 inline-flex items-center gap-3">
            <span className="h-px w-10" style={{
            backgroundColor: "hsl(142 76% 45%)"
          }} aria-hidden="true" />
            <span className="font-mono text-xs tracking-[0.3em] uppercase" style={{
            color: "hsl(142 76% 45%)"
          }}>
              Now Scheduling — Seasonal Maintenance
            </span>
          </div>

          {}
          <h2 className="font-default font-extrabold leading-[0.9] tracking-tighter mb-8" style={{
          color: "hsl(0 0% 98%)",
          fontSize: "clamp(2.5rem, 8vw, 5rem)"
        }}>
            Ready for a{" "}
            <em className="not-italic" style={{
            color: "hsl(142 76% 45%)"
          }}>
              greener
            </em>{" "}
            lawn today?
          </h2>

          {}
          <p className="font-default text-lg md:text-xl leading-relaxed mb-10 max-w-xl mx-auto md:mx-0" style={{
          color: "hsl(210 10% 70%)"
        }}>
            Acosta's Landscaping delivers precision mowing and architectural edging. 
            Our schedule fills fast—reserve your slot now for a lawn that stands 
            out in every neighborhood.
          </p>

          {}
          <div className="flex flex-col sm:flex-row gap-4 mb-12 items-center md:items-start justify-center md:justify-start">
            <Button asChild size="lg" className="rounded-md h-14 px-8 text-base font-bold shadow-lg group" style={{
            backgroundColor: "hsl(142 76% 45%)",
            color: "hsl(150 20% 6%)"
          }}>
              <Link to="/GetQuotePage">
                Get Your Quote
                <ArrowRight className="ml-1 size-5 transition-transform group-hover:translate-x-1" />
              </Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="rounded-md h-14 px-8 text-base font-bold bg-transparent backdrop-blur-sm" style={{
            borderColor: "hsl(210 10% 40%)",
            color: "hsl(0 0% 98%)"
          }}>
              <Link to="tel:6823205738">
                <PhoneCall className="size-4" />
                Call (682) 320-5738
              </Link>
            </Button>
          </div>

          {}
          <div className="flex flex-wrap items-center justify-center md:justify-start gap-x-2 gap-y-4">
            {trustSignals.map((signal, i) => {
            const Icon = signal.icon;
            return <div key={i} data-index={i} className="inline-flex items-center gap-2">
                  <Icon className="size-4" style={{
                color: "hsl(142 76% 45%)"
              }} />
                  <span className="font-mono text-xs tracking-[0.15em] uppercase" style={{
                color: "hsl(210 10% 70%)"
              }}>
                    {signal.label}
                  </span>
                  {i < trustSignals.length - 1 && <span className="mx-3 inline-block size-1 rounded-lg" style={{
                backgroundColor: "hsl(210 10% 40%)"
              }} aria-hidden="true" />}
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}